import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-slate-800 bg-slate-900 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-184" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-185" data-mp="36lwicv7rghm4">
        <span className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-950 px-4 py-2 text-xs font-medium text-slate-200" data-id="element-186" data-mp="31lqy403tlxe2">
          <AwardIcon className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-187" data-mp="2ws5w7wz3wj9l" /> The Most Complete Underground Mining & Mine Operations Professional System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-188" data-mp="2nv5e282mrhel">
          {productBrand} — <span className="text-amber-400" data-id="element-189" data-mp="2iswh70mmzv77">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-medium text-slate-300" data-id="element-190" data-mp="2dw614dau0zls">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-xl border border-slate-700 bg-slate-950 p-6 text-left text-lg font-medium leading-relaxed text-white shadow-sm" data-id="element-191" data-mp="13x4yjzxcdj92">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-orange-400" aria-hidden="true" data-id="element-192" data-mp="u2v7clk4yqzx" />
          A complete visual technical reference to understand how an underground mine works: how it is laid out and
          accessed, how ore is mined and the ground is supported, how the drill-and-blast cycle, ventilation and services
          run, and how ore moves safely from the draw point to the surface.
        </p>
      </div>
    </section>;
}